module.exports = __webpack_public_path__ + "img/service2.babe2448.png";